import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/validationSpecialistQuestionnaires';
import { isVSSchema } from '@utils/validationSpecialist';
import { actions } from './ValidationSpecialistQuestionnaires.slice';

import {
  GetEDTFSchemasFetchAction,
  UpdateUploadFormAction,
} from './ValidationSpecialistQuestionnaires.types';
import { Resp, dispatch } from '../helpers';
import { runToast, showErrorToast } from '../tools';

export function* getEDTFSchemasWorker(
  action: GetEDTFSchemasFetchAction
) {
  try {
    const { clinicalTrialId, dataType, visitDefinitionId } = action.payload;
    const response: Resp<typeof api.fetchValidationSpecialistQuestionnaires> = yield call<
      typeof api.fetchValidationSpecialistQuestionnaires
    >(api.fetchValidationSpecialistQuestionnaires, clinicalTrialId, dataType, visitDefinitionId);
    // Keep only Validation Specialist questionnaires (formType 'VS')
    const vsSchemas = response.filter(isVSSchema);
    yield dispatch(actions.getEDTFSchemasSuccess(vsSchemas));
  } catch (error) {
    yield dispatch(actions.getEDTFSchemasFailure(error as Error));
  }
}

export function* updateParticipantFormWorker({ payload }: UpdateUploadFormAction) {
  try {
    const response: Resp<typeof api.updateParticipantForm> = yield call(api.updateParticipantForm, {
      data: payload.data,
      uploadItemId: payload.uploadItemId,
      questionnaireId: payload.questionnaireId,
      clinicalTrialId: payload.clinicalTrialId,
    });

    yield dispatch(actions.updateParticipantFormSuccess(response.data));
    yield call(runToast, 'success', 'Participant form has been updated');
  } catch (error) {
    yield showErrorToast(error, 'Failed to update participant form');
    yield dispatch(actions.updateParticipantFormFailure(error as Error));
  }
}

export function* ValidationSpecialistQuestionnairesSaga() {
  yield takeLatest(actions.getEDTFSchemas.type, getEDTFSchemasWorker);
  yield takeLatest(actions.updateParticipantForm.type, updateParticipantFormWorker);
}
